import messages from '../locales/messages';

const profile = {
  firstName: 'Elton',
  lastName: 'Lucien',
  headline: messages['hero.headline'],
  description: messages['hero.description'],
  aboutMeMessage: messages['about.message'],
  email: 'contact@eltonlucien.com',
  phone: '7864064185',
  location: 'Miami, FL',
  img: 'profile.jpg',
  links: {
    github: 'https://github.com/Elton360',
    linkedin: 'https://linkedin.com/in/elton-lucien-b739348b',
    spotify: 'https://open.spotify.com/user/ba8p1wtfbr4nlg65ardpmyn8a',
  },
  // Dates are "YYYY-MM"; they're shown as month and year in the visitor's language
  experiences: [
    {
      id: 'kaseya-se2',
      name: 'Kaseya (Datto)',
      location: 'Miami, FL',
      title: messages.softwareEngineer2,
      from: '2025-02',
      tags: [
        'React',
        'TypeScript',
        'AntD',
        'Node',
        'Express',
        'GraphQL',
        'Java',
        'Spring Boot',
      ],
      highlights: [
        messages['experience.se2.aiInsights'],
        messages['experience.se2.modernization'],
        messages['experience.se2.billing'],
        messages['experience.se2.angularMigration'],
        messages['experience.se2.quality'],
      ],
    },
    {
      id: 'kaseya-se1',
      name: 'Kaseya (Datto)',
      location: 'Miami, FL',
      title: messages.softwareEngineer1,
      from: '2022-10',
      to: '2025-02',
      highlights: [
        messages['experience.se1.features'],
        messages['experience.se1.designStandards'],
        messages['experience.se1.collaboration'],
      ],
    },
  ],
  projects: [
    {
      id: 'magda-codex',
      name: 'Magda Codex',
      imageSrc: 'work/magdex.png',
      link: 'https://magdex.org',
      subtitle: messages['project.magdaCodex.subtitle'],
      description: messages['project.magdaCodex.description'],
      highlights: [
        messages['project.magdaCodex.saas'],
        messages['project.magdaCodex.presenter'],
        messages['project.magdaCodex.cms'],
      ],
      tags: ['TypeScript', 'React', 'Express', 'SQLite', 'Docker'],
    },
    {
      id: 'homelab',
      name: 'Homelab Dashboard',
      imageSrc: 'work/homelab.png',
      link: 'https://adzvitalis.us',
      github: 'https://github.com/Elton360/homelab-dashboard',
      subtitle: messages['project.homelab.subtitle'],
      description: messages['project.homelab.description'],
      highlights: [
        messages['project.homelab.server'],
        messages['project.homelab.dashboard'],
      ],
      tags: ['React', 'Node.js', 'GraphQL', 'Docker', 'Prometheus'],
    },
    {
      id: 'portfolio',
      name: 'Portfolio Template',
      imageSrc: 'work/elton_2.png',
      link: 'https://eltonlucien.com',
      github: 'https://github.com/Elton360/portfolio_site_v2',
      subtitle: messages['project.portfolio.subtitle'],
      description: messages['project.portfolio.description'],
      highlights: [
        messages['project.portfolio.components'],
        messages['project.portfolio.i18n'],
      ],
      tags: [
        'React',
        'JavaScript',
        'Ant Design',
        'styled-components',
        'React Intl',
      ],
    },
    {
      id: 'oware',
      name: 'Oware',
      imageSrc: 'work/oware.png',
      link: 'https://oware.eltonlucien.com',
      github: 'https://github.com/Elton360/Oware',
      subtitle: messages['project.oware.subtitle'],
      description: messages['project.oware.description'],
      highlights: [
        messages['project.oware.mechanics'],
        messages['project.oware.tests'],
      ],
      tags: ['JavaScript', 'HTML', 'CSS', 'Vitest'],
    },
    {
      id: 'grocery',
      name: 'Grocery Optimizer',
      imageSrc: 'work/grocery.png',
      github: 'https://github.com/Elton360/grocery',
      subtitle: messages['project.grocery.subtitle'],
      description: messages['project.grocery.description'],
      highlights: [
        messages['project.grocery.extension'],
        messages['project.grocery.matching'],
      ],
      tags: ['JavaScript', 'React', 'Express', 'SQLite', 'Chromium Extensions'],
    },
  ],
};

export default profile;
